import { render, staticRenderFns } from "./PatientChangeRegimenNew.vue?vue&type=template&id=723ed4d5"
import script from "./PatientChangeRegimenNew.vue?vue&type=script&lang=js"
export * from "./PatientChangeRegimenNew.vue?vue&type=script&lang=js"
import style0 from "./PatientChangeRegimenNew.vue?vue&type=style&index=0&id=723ed4d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports